import { render } from "./FileActions.vue?vue&type=template&id=6909176e&scoped=true&lang=pug"
import script from "./FileActions.vue?vue&type=script&lang=js"
export * from "./FileActions.vue?vue&type=script&lang=js"

import "./FileActions.vue?vue&type=style&index=0&id=6909176e&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6909176e"]])

export default __exports__